import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ExportEmployeeSelector = ({ form }: Props) => {
  const [selectedEmployeeIds, setSelectedEmployeeIds] = React.useState<number[]>([])

  useEffect(() => {
    form.setValues({
      employee_ids: selectedEmployeeIds,
    })
  }, [selectedEmployeeIds.length]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FormRow>
        <Box className="sidebar_employees_export_employee_data_timeoff_employees_button">
          <EmployeeSelectorV2
            messages={{
              placeholder: i18n.t('employees.reports.employees'),
            }}
            forcedFilters={{
              employeeIds: selectedEmployeeIds,
            }}
            onChange={(state) => setSelectedEmployeeIds(state.type === 'manual' ? state.ids : [])}
            multiple
          />
        </Box>
      </FormRow>
    </>
  )
}

export default ExportEmployeeSelector
